import React from 'react';
const targets = [{
  title: 'Moms and dads',
  desc: 'who want a beautiful party without spending a fortune',
  color: 'bg-pink-400'
}, {
  title: 'People with no experience',
  desc: 'in design who want professional results',
  color: 'bg-orange-400'
}, {
  title: 'Entrepreneurs',
  desc: 'who want to offer party decoration services',
  color: 'bg-teal-400'
}, {
  title: 'Busy people',
  desc: 'who need quick and easy results',
  color: 'bg-purple-400'
}];
export function WhoItsFor() {
  return <section className="py-16 px-4 bg-light-pink" data-id="element-481">
      <div className="max-w-4xl mx-auto" data-id="element-482">
        <h2 className="text-3xl md:text-5xl font-bold text-center text-magenta mb-12" data-id="element-483">
          🎯 WHO IS THIS KIT FOR?
        </h2>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-484">
          {targets.map((target, index) => <div key={index} className="bg-white rounded-3xl p-6 shadow-md border-2 border-pink-100 flex items-start gap-4 hover:border-pink-300 transition-colors" data-id="element-485">
              <div className={`${target.color} text-white rounded-full p-2 flex-shrink-0 shadow-sm`} data-id="element-486">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-487">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" data-id="element-488"></path>
                </svg>
              </div>
              <div data-id="element-489">
                <h3 className="text-xl font-bold text-gray-800 mb-1 font-baloo" data-id="element-490">
                  {target.title}
                </h3>
                <p className="text-gray-600 font-medium" data-id="element-491">{target.desc}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}